export function normalizeInviteCode(input) {
  return String(input || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function formatInviteCode(input) {
  const normalized = normalizeInviteCode(input).slice(0, 15);
  if (!normalized) return '';
  const p1 = normalized.slice(0, 5);
  const p2 = normalized.slice(5, 10);
  const p3 = normalized.slice(10, 15);
  return [p1, p2, p3].filter(Boolean).join('-');
}

export function validateInviteCode(normalized) {
  return normalizeInviteCode(normalized).length === 15;
}

export function generateInviteCodeNormalized() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 15; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
